import { Eye } from "lucide-react";
import Loading from "../../../components/loading";
import CustomPagination from "../../../components/paginate";
import libFloat from "../../../util/libFloat";
import LibDateTime from "../../../util/libDateTime";
import { formatarCpfCnpj } from "../../../util/documento";

const FIXA = "sticky right-0 !shadow-[-6px_0_6px_-6px_rgba(0,0,0,0.15)]";

export const CABECALHO_FIXO = `${FIXA} ![background-color:var(--texto-secondary)]`;
export const CELULA_FIXA = `${FIXA} !bg-white group-hover:!bg-[#f5f7fa]`;

export function dataHora(valor) {
	return LibDateTime.parseDelphiLocal(valor, "dd/MM/yyyy HH:mm") || "—";
}

export function moeda(valor) {
	return valor == null ? "—" : libFloat.strToCurrency(valor);
}

export function Cliente({ nome, documento }) {
	return (
		<>
			<div className="font-medium text-gray-800">
				{nome || <span className="font-normal text-gray-400">Consumidor final</span>}
			</div>
			{documento && <div className="text-xs text-gray-500">{formatarCpfCnpj(documento)}</div>}
		</>
	);
}

export const COLUNA_DETALHES = { rotulo: "", classe: `text-center w-32 ${CABECALHO_FIXO}` };

export function CelulaDetalhes({ onAbrir }) {
	return (
		<td className={`align-middle text-center ${CELULA_FIXA}`}>
			<button
				type="button"
				onClick={(e) => {
					e.stopPropagation();
					onAbrir();
				}}
				className="btn btn-sm btn-outline-primary inline-flex items-center gap-1.5 whitespace-nowrap"
			>
				<Eye size={14} />
				Detalhes
			</button>
		</td>
	);
}

export function Motivo({ item }) {
	const texto = [item.cstat, item.motivo].filter(Boolean).join(" · ") || "—";

	return (
		<div className="truncate max-w-[280px]" title={texto}>
			{texto}
		</div>
	);
}

export default function TabelaFiscal({ colunas, total, pagina, totalPaginas, onPagina, carregando, vazio, children }) {
	const handleChangePage = (event, novaPagina) => {
		if (novaPagina >= 1 && novaPagina <= totalPaginas) onPagina(novaPagina);
	};

	return (
		<div className="flex-1 flex flex-col min-h-[320px] border rounded-md bg-white border-gray-300 overflow-hidden">
			<div className="flex-1 overflow-auto">
				<table className="table table-portal mb-0 w-full min-w-[1100px] border-b">
					<thead className="color-table sticky top-0 z-10 shadow-sm">
						<tr>
							{colunas.map((coluna) => (
								<th key={coluna.rotulo} className={`${coluna.classe} font-semibold py-2 border-b`}>
									<span className="text-color-table">{coluna.rotulo}</span>
								</th>
							))}
						</tr>
					</thead>

					<tbody>
						{!carregando && children}

						{total === 0 && !carregando && (
							<tr>
								<td colSpan={colunas.length} className="text-center text-gray-400 py-10">
									{vazio}
								</td>
							</tr>
						)}
					</tbody>
				</table>
			</div>

			{carregando && (
				<div className="flex h-44">
					<Loading mensagem="Buscando..." />
				</div>
			)}

			{total > 0 && !carregando && (
				<CustomPagination
					page={pagina}
					onChangePage={handleChangePage}
					totalPage={totalPaginas}
					totalRecord={total}
				/>
			)}
		</div>
	);
}
